import { useState } from "react";
import "../styles/why.css";
import {
  FaAward,
  FaUserMd,
  FaHeadphones,
  FaHandsHelping,
  FaClock,
  FaHeart,
} from "react-icons/fa";

function Why() {
  const [active, setActive] = useState(null);

  const features = [
    {
      icon: <FaAward />,
      title: "35+ Years Experience",
      desc: "Trusted hearing care with thousands of satisfied patients.",
    },
    {
      icon: <FaUserMd />,
      title: "Expert Audiologists",
      desc: "Professional hearing assessments and personalized solutions.",
    },
    {
      icon: <FaHeadphones />,
      title: "Latest Hearing Aids",
      desc: "Advanced digital hearing aids from leading global brands.",
    },
    {
      icon: <FaHandsHelping />,
      title: "Complete Support",
      desc: "From consultation to fitting and after-sales service.",
    },
    {
      icon: <FaClock />,
      title: "Quick Appointments",
      desc: "Easy appointment scheduling with minimal waiting time.",
    },
    {
      icon: <FaHeart />,
      title: "Customers First",
      desc: "Every hearing solution is customized for your lifestyle.",
    },
  ];

  const faqs = [
    {
      question: "How long do hearing aids last?",
      answer:
        "Most hearing aids last between 3 to 5 years with proper care and regular servicing.",
    },
    {
      question: "Do hearing aids need servicing?",
      answer:
        "Yes. Regular cleaning and servicing ensure optimal performance and longer lifespan.",
    },
    {
      question: "Will hearing aids cure hearing loss?",
      answer:
        "No. Hearing aids do not cure hearing loss, but they significantly improve hearing and communication.",
    },
    {
      question: "Can I wear hearing aids all day?",
      answer:
        "Yes. Most users wear them throughout the day for maximum benefit and comfort.",
    },
    {
      question: "How much do hearing aids cost?",
      answer:
        "The cost depends on the hearing aid model, technology level, and features. We offer a range of options to suit different hearing needs and budgets.",
    },
    {
      question: "How long does a hearing test take?",
      answer:
        "A complete hearing evaluation usually takes about 30 to 45 minutes and is completely painless.",
    },
    {
      question: "Can children and seniors use hearing aids?",
      answer:
        "Yes. Hearing aids are available for people of all ages and are carefully selected based on individual hearing requirements.",
    },
    {
      question: "How long do hearing aid batteries last?",
      answer:
        "Battery life varies depending on the hearing aid model and usage, but most batteries last between 5 to 14 days.",
    },
  ];

  const toggleFAQ = (index) => {
    setActive(active === index ? null : index);
  };

  return (
    <section className="why">

      <div className="section-title">

        <span><h1>Why Choose Us</h1></span>

        <h2>Your Trusted Hearing Care Partner</h2>

        <p>
          We combine experience, advanced technology, and compassionate care
          to help you hear better and live better.
        </p>

      </div>

      <div className="why-container">

        {features.map((item, index) => (

          <div className="why-card" key={index} data-aos="zoom-in" data-aos-duration="900" data-aos-delay={index * 150}>

            <div className="why-icon">{item.icon}</div>

            <h3>{item.title}</h3>

            <p>{item.desc}</p>

          </div>

        ))}

      </div>

      {/* FAQ */}

      <div className="faq-section">

        <div className="faq-title">

          <h2>Frequently Asked Questions</h2>

          <p>Answers to common questions about hearing aids.</p>

        </div>

        <div className="faq-container">

          {faqs.map((faq, index) => (

            <div
              className={`faq-item ${active === index ? "active" : ""}`}
              key={index}
            >

              <button
                className="faq-question"
                onClick={() => toggleFAQ(index)}
              >

                <span>{faq.question}</span>

                <span className="faq-icon">
                  {active === index ? "−" : "+"}
                </span>

              </button>

              <div className="faq-answer">

                <p>{faq.answer}</p>

              </div>

            </div>

          ))}

        </div>

      </div>

    </section>
  );
}

export default Why;